import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Features() {
  return (
    <section
      id="features"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Recursos do Sistema</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-5">
          Uma plataforma completa para todas as necessidades da sua agência
        </p>
        <div className="row">
          <div className="col-lg-4 align-self-center">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-users" />
                  </div>
                  <h3>CRM Avançado</h3>
                  <p>
                    Gestão completa de clientes, leads e vendas com
                    acompanhamento automatizado de todo funil comercial.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-project-diagram" />
                  </div>
                  <h3>Gestão de Projetos</h3>
                  <p>
                    Controle completo de projetos, tarefas e prazos com
                    dashboards visuais e relatórios em tempo real.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-robot" />
                  </div>
                  <h3>Automação N8N</h3>
                  <p>
                    Fluxos automatizados integrados para conectar
                    todos os processos e eliminar tarefas repetitivas.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center mb-4 mb-xl-0">
            <img
              alt="Sistema Integrare"
              src="images/app-showcase-feature.png"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-4 align-self-center">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-chart-line" />
                  </div>
                  <h3>Dashboards Inteligentes</h3>
                  <p>
                    Visualização completa de indicadores e métricas
                    com gráficos dinâmicos para tomada de decisão.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-dollar-sign" />
                  </div>
                  <h3>Controle Financeiro</h3>
                  <p>
                    Gestão de orçamentos, despesas e receitas com
                    controle de fluxo de caixa e relatórios financeiros.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-shield-alt" />
                  </div>
                  <h3>Segurança Avançada</h3>
                  <p>
                    Autenticação multi-nível, backup automático e
                    segurança de dados com criptografia completa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
